import {Component, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {throwError} from 'rxjs';
//generic
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DynamicFormComponent} from 'app/core-ui/dynamic-form/containers/dynamic-form/dynamic-form.component';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ApproveClientUploadRowComponent} from '../ApproveClientUploadRow/approveClientUploadRow.component';
import {TrankInvitationsService} from './trackInvitations.service';

@Component({
  selector: 'trackInvitations-grid',
  templateUrl: './trackInvitations.component.html',
  providers: [TrankInvitationsService],
})
export class TrackInvitations extends BaseGridNoCookieComponent<TrankInvitationsService> {
  @ViewChild(DynamicFormComponent)
  public form: DynamicFormComponent;

  @ViewChild('confirmModal')
  public confirmModal: ModalDirective;
  @ViewChild('rejectModal')
  public rejectModal: ModalDirective;
  @ViewChild(ApproveClientUploadRowComponent)
  ApproveClientUploadRowComponent;

  public submiting: boolean = false;
  public viewRole: any;

  constructor(
    public gridService: TrankInvitationsService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'trackInvitations');
    let params = this.route.snapshot.queryParamMap.get('status');
    this.logger.log(params);
    if (this.form && this.form.controls.length > 0 && params && params != '') {
      this.form.setValue('invStatusFull', params);
      this.submit(this.form.value);
    }
    this.loadVisuals();
    this.viewRole = this.securityService.isOtherStaff() || this.securityService.isAdmin();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });

    this.checkboxPK = 'cookieid';
  }

  getCheckboxCallback() {
    this.checkboxPKArray = [];
    this.checkboxPKArrayFull = [];
    this.gridService.getPKs(this.dataCountParams()).subscribe({
      next: (data) => {
        this.checkboxPKArrayFull = data.data;
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }
  public rowClick(params) {
    this.router.navigate(['/menu/7305']);
    localStorage.setItem('invId', params.invId);
    localStorage.setItem('isClient', params.isClient);
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {
    if (event.modalname == 'debtorModal') {
      this.form.setValue('debtorId', event.value.dbtrId);
    }
  }

  afterFormInit(formConfig: any) {
    let params = this.route.snapshot.queryParamMap.get('status');
    let debtorId = this.route.snapshot.queryParamMap.get('buyerId');
    let hasUrlParamKey =
      this.route.snapshot.queryParams.hasOwnProperty('status') ||
      this.route.snapshot.queryParams.hasOwnProperty('buyerId');
    if (this.form && this.form.controls.length > 0 && hasUrlParamKey) {
      this.form.setValue('invStatusFull', params);
      this.form.setValue('debtorId', debtorId);
      this.submit(this.form.value);
    }
  }

  public confirmApprove() {
    this.submiting = true;
    this.gridService.approve(this.checkboxPKArray).subscribe({
      next: (data) => {
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.confirmModal.hide();
        this.submiting = false;
        this.search();
      },
      error: (error) => {
        this.submiting = false;
        this.confirmModal.hide();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }
  public confirmReject() {
    this.submiting = true;
    this.gridService.reject(this.checkboxPKArray).subscribe({
      next: (data) => {
        console.log(data);
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.rejectModal.hide();
        this.submiting = false;
        this.search();
      },
      error: (error) => {
        this.submiting = false;
        this.rejectModal.hide();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }

  public initiateApprove(params) {
    this.confirmModal.show();
  }
  public initiateReject(params) {
    this.rejectModal.show();
  }

  public cookieInput;

  public rowModal(params) {
    this.cookieInput = params['cookieid'];

    this.ApproveClientUploadRowComponent.ngOnChanges({
      id: {currentValue: this.cookieInput},
    });

    this.ApproveClientUploadRowComponent.showChildModal();
  }
}
